<template>

    <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.5 8.35742V12.8574" stroke="white"/>
<circle cx="4.5" cy="4.5" r="4" stroke="white"/>
</svg>

</template>